<template>
  <div>
    <div v-if="successPost" class="d-flex justify-content-center">
      <div class="alert alert-success text-center w-95" role="alert">
        <span class="font-weight-bold">Your insurance data has been saved successfully !</span><br>
        <span class="font-size-small">You can check your insurance data by clicking on "View Previous" button.</span>
        <button @click="hideShowAlertMessage" type="button" class="float-right btn btn-outline-secondary btn-sm">X</button>
      </div>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.companyname.$touch()" v-model="userDataForm.companyname" type="text" name="companyName" id="companyName" class="form-control" placeholder="Company Name">
            <div class="input-group-append">
              <label for="companyName" class="input-group-text bg-color-grey text-white">Company Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.companyname.$error">
            <span v-if="!$v.userDataForm.companyname.minLength" class="text-danger">* Please enter a name with at least {{ $v.userDataForm.companyname.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.companyname.minLength && !$v.userDataForm.companyname.required">
            <span v-if="!$v.userDataForm.companyname.required" class="text-danger">* Please enter company name !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.applicantname.$touch()" v-model="userDataForm.applicantname" type="text" name="applicantName" id="applicantName" class="form-control" placeholder="Applicant Name">
            <div class="input-group-append">
              <label for="applicantName" class="input-group-text bg-color-grey text-white">Applicant Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.applicantname.$error">
            <span v-if="!$v.userDataForm.applicantname.minLength" class="text-danger">* Please enter a name with at least {{ $v.userDataForm.applicantname.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.applicantname.minLength && !$v.userDataForm.applicantname.required">
            <span v-if="!$v.userDataForm.applicantname.required" class="text-danger">* Please enter applicant name !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.title.$touch()" v-model="userDataForm.title" type="text" name="applicantTitle" id="applicantTitle" class="form-control" placeholder="Tile of Applicant">
            <div class="input-group-append">
              <label for="applicantTitle" class="input-group-text bg-color-grey text-white">Title</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.title.$error">
            <span v-if="!$v.userDataForm.title.minLength" class="text-danger">* Title must have at least  {{ $v.userDataForm.title.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.title.minLength && !$v.userDataForm.title.required">
            <span v-if="!$v.userDataForm.title.required" class="text-danger">* Please enter title of applicant !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.email.$touch()" v-model="userDataForm.email" type="text" name="companyEmail" id="companyEmail" class="form-control" placeholder="Email Address">
            <div class="input-group-append">
              <label for="companyEmail" class="input-group-text bg-color-grey text-white">Email Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.email.$error">
            <span v-if="!$v.userDataForm.email.email" class="text-danger">* Please enter a valid email address !</span>
            <br v-if="!$v.userDataForm.email.email && !$v.userDataForm.email.required">
            <span v-if="!$v.userDataForm.email.required" class="text-danger">* Please enter email address !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.companytype.$touch()" v-model="userDataForm.companytype" type="text" name="companyType" id="companyType" class="form-control" placeholder="Company Type">
            <div class="input-group-append">
              <label for="companyType" class="input-group-text bg-color-grey text-white">Company type</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.companytype.$error">
            <span v-if="!$v.userDataForm.companytype.minLength" class="text-danger">* Type must have at least {{ $v.userDataForm.companytype.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.companytype.minLength && !$v.userDataForm.companytype.required">
            <span v-if="!$v.userDataForm.companytype.required" class="text-danger">* Please enter type of company !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.address.$touch()" v-model="userDataForm.address" type="text" name="companyAddress" id="companyAddress" class="form-control" placeholder="Address(City, State, Zip)">
            <div class="input-group-append">
              <label for="companyAddress" class="input-group-text bg-color-grey text-white">Address (City, State, Zip)</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.address.$error">
            <span v-if="!$v.userDataForm.address.minLength" class="text-danger">* Please enter company address with at least {{ $v.userDataForm.address.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.address.minLength && !$v.userDataForm.address.required">
            <span v-if="!$v.userDataForm.address.required" class="text-danger">* Please enter company address !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.phonenumber.$touch()" v-model="userDataForm.phonenumber" type="number" name="phoneNumber" id="phoneNumber" class="form-control" placeholder="Phone Number">
            <div class="input-group-append">
              <label for="phoneNumber" class="input-group-text bg-color-grey text-white">Telephone</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.phonenumber.$error">
            <span v-if="!$v.userDataForm.phonenumber.minLength" class="text-danger">* Please a phone number with at least {{ $v.userDataForm.phonenumber.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.minLength && !$v.userDataForm.phonenumber.numeric">
            <span v-if="!$v.userDataForm.phonenumber.numeric" class="text-danger">* Phone number must contain only digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.numeric && !$v.userDataForm.phonenumber.required">
            <span v-if="!$v.userDataForm.phonenumber.required" class="text-danger">* Please enter a phone number !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.numberemployees.$touch()" v-model="userDataForm.numberemployees" type="number" name="companyNumberEmployees" id="companyNumberEmployees" class="form-control" placeholder="Number of Employees">
            <div class="input-group-append">
              <label for="companyNumberEmployees" class="input-group-text bg-color-grey text-white">Number Employees</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.numberemployees.$error">
            <span v-if="!$v.userDataForm.numberemployees.between" class="text-danger">* Number must be between {{ $v.userDataForm.numberemployees.$params.between.min }} and {{ $v.userDataForm.numberemployees.$params.between.max }} !</span>
            <br v-if="!$v.userDataForm.numberemployees.between && !$v.userDataForm.numberemployees.required">
            <span v-if="!$v.userDataForm.numberemployees.required" class="text-danger">* Please enter number of employees !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.website.$touch()" v-model="userDataForm.website" type="url" name="companyWebsite" id="companyWebsite" class="form-control" placeholder="Company website">
            <div class="input-group-append">
              <label for="companyWebsite" class="input-group-text bg-color-grey text-white">www</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.website.$error">
            <span v-if="!$v.userDataForm.website.minLength" class="text-danger">* Please enter a valid url !</span>
            <br v-if="!$v.userDataForm.website.minLength && !$v.userDataForm.website.required">
            <span v-if="!$v.userDataForm.website.required" class="text-danger">* Please enter url of company website !</span>
          </div>
        </div>
        <div class="form-group w-md-45 mt-3 mt-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text bg-color-grey text-white" for="companyYearsEstablished">Year Established</label>
            </div>
            <select @blur="$v.userDataForm.yearsestablished.$touch()" v-model="userDataForm.yearsestablished" class="form-control custom-select" name="companyYearsEstablished" id="companyYearsEstablished">
              <option value="none">Select a year</option>
              <option :key="index" :value="year" :label="year"  v-for="(year, index) of years">{{ year }}</option>
            </select>
          </div>
          <div v-if="$v.userDataForm.yearsestablished.$error">
            <span v-if="!$v.userDataForm.yearsestablished.numeric" class="text-danger">* Please enter a valid year !</span>
            <br v-if="!$v.userDataForm.yearsestablished.numeric && !$v.userDataForm.yearsestablished.required">
            <span v-if="!$v.userDataForm.yearsestablished.required" class="text-danger">* Please enter company year established !</span>
          </div>
        </div>
      </div>
      <div class="text-center mb-5">
        <button type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">Submit</button>
        <div class="divEmptyBox text-center" v-if="$v.userDataForm.$invalid" v-on:click="$store.state.invalidFormAlert">
          <div class="emptyBox"><span class="invisible">Submit</span></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FORM_CYBER_VALIDATIONS } from '../../../../validations/formCyber'
export default {
  name: 'InsuranceFormCyber',
  props: {
    insuranceType: {
      type: String
    },
    defaultFontStyle: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    return {
      listOfCountries: this.$store.state.countries,
      years: this.$store.state.years,
      userDataForm: {
        companyname: null,
        applicantname: null,
        email: null,
        companytype: null,
        address: null,
        title: null,
        phonenumber: null,
        yearsestablished: null,
        numberemployees: null,
        website: null
      },
      successPost: false
    }
  },
  methods: {
    hideShowAlertMessage () {
      this.successPost = !this.successPost
    },
    onSubmit () {
      let type = null
      this.insuranceType === 'AppInsuranceFormCyber' ? type = 'Cyber' : type = null
      console.log('insuranceType = ' + type)
      const formData = {
        typeinsurance: type,
        ownerinsurance: this.$store.getters.email,
        companyname: this.userDataForm.companyname,
        applicantname: this.userDataForm.applicantname,
        email: this.userDataForm.email,
        companytype: this.userDataForm.companytype,
        address: this.userDataForm.address,
        title: this.userDataForm.title,
        phonenumber: this.userDataForm.phonenumber,
        yearsestablished: this.userDataForm.yearsestablished,
        numberemployees: this.userDataForm.numberemployees,
        website: this.userDataForm.website
      }
      console.log(formData)
      this.$store.dispatch('postInsurance', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successPost = true : this.successPost = false
          console.log('response axios post insurance = ' + isSuccess)
        })
    }
  },
  validations: FORM_CYBER_VALIDATIONS
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/forms/InsuranceFormCyber.vue